import React from "react";
import { Route, IndexRoute, Redirect } from "react-router";
import PropTypes from "prop-types";
import App from "components/App";
import PageLoader from "components/widgets/PageLoader";
import AppHomeRoute from "routes/AppHomeRoute";
import MerchantRoute from "routes/MerchantRoute";
import RegisterRoutes from "./RegisterRoutes";
import ResetPasswordRoutes from "./ResetPasswordRoutes";

import { USA_HOST, SG_HOST, MY_HOST, VN_HOST, PH_HOST } from "config";

import { async, scrollToTop } from "components/helpers/routerUtils";

const Home = async(() => import("components/pages/Home"));
const ConfirmEmailResult = async(() =>
  import("components/pages/ConfirmEmailResult")
);
const ConfirmEmail = async(() => import("components/pages/ConfirmEmail"));
const Corp = async(() => import("components/pages/Corp"));
const Business = async(() => import("components/pages/Business"));
const Contact = async(() => import("components/pages/Contact"));
const HowItWorks = async(() =>
  import("components/pages/HowItWorks/HowItWorks")
);
const HowItWorksProcess = async(() =>
  import("components/pages/HowItWorks/Process")
);
const HowItWorksProcessInternational = async(() =>
  import("components/domains/zaployalty.com/pages/HowItWorks/Process")
);
const HowItWorksFaq = async(() => import("components/pages/HowItWorks/Faq"));
const Login = async(() => import("components/pages/Login"));
const Merchants = async(() => import("components/pages/Merchants"));
const Merchant = async(() => import("components/pages/Merchant"));
const Privacy = async(() => import("components/pages/Privacy/Privacy"));
const Terms = async(() => import("components/pages/Terms"));
const Careers = async(() => import("components/pages/Careers/Careers"));
const CareersHome = async(() =>
  import("components/pages/Careers/Careers-Home")
);
const ManagementTraineeCebu = async(() =>
  import("components/pages/Careers/Management-Trainee-Cebu")
);
const ManagementTraineeManila = async(() =>
  import("components/pages/Careers/Management-Trainee-Manila")
);
const DeveloperManila = async(() =>
  import("components/pages/Careers/Developer-Manila")
);
const Dashboard = async(() => import("components/pages/Dashboard"));
const Transactions = async(() => import("components/pages/Transactions"));
const Wallet = async(() => import("components/pages/Wallet"));
const Profile = async(() => import("components/pages/Profile"));
const RedirectToStore = async(() => import("components/pages/RedirectToStore"));

function returnProcess() {
  switch (document.domain) {
    case USA_HOST:
    case SG_HOST:
    case MY_HOST:
    case VN_HOST:
      return HowItWorksProcessInternational;
    default:
      return HowItWorksProcess;
  }
}

function loginRoute() {
  switch (document.domain) {
    case USA_HOST:
    case SG_HOST:
    case VN_HOST:
      return <div />;
    default:
      return (
        <Route
          path="login"
          getComponent={Login}
          queries={AppHomeRoute.queries}
        />
      );
  }
}

function indexRoute() {
  return <IndexRoute getComponent={Home} queries={AppHomeRoute.queries} />;
}

function registerRoutes() {
  switch (document.domain) {
    case USA_HOST:
    case SG_HOST:
    case VN_HOST:
      return <div />;
    default:
      return RegisterRoutes;
  }
}

function resetPasswordRoutes() {
  switch (document.domain) {
    case USA_HOST:
    case SG_HOST:
    case VN_HOST:
      return <div />;
    default:
      return ResetPasswordRoutes;
  }
}

export const PageLoading = (Component, { props }) =>
  props ? <Component {...props} /> : <PageLoader />;

export const ParentRoute = (props) => (
  <div id="container">
    <div id="body">{props.children}</div>
  </div>
);
ParentRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default (
  <Route
    path="/"
    queries={AppHomeRoute.queries}
    component={App}
    onChange={scrollToTop}
    render={(args) => PageLoading(App, args)}
  >
    {loginRoute()}
    {indexRoute()}
    <Route path="home" getComponent={Home} queries={AppHomeRoute.queries} />
    <Route
      path="confirm-email-result/:status"
      getComponent={ConfirmEmailResult}
    />
    <Route
      path="confirm-email/:zapperId/confirm/:confirmationKey"
      getComponent={ConfirmEmail}
    />
    <Route path="corp/:corpName" getComponent={Corp} />
    <Route path="business" getComponent={Business} />
    <Route path="contact" getComponent={Contact} />
    <Redirect from="how-it-works" to="/how-it-works/process" />
    <Route path="how-it-works" getComponent={HowItWorks}>
      <Route path="process" getComponent={returnProcess()} />
      <Route path="faq" getComponent={HowItWorksFaq} />
    </Route>
    <Route
      path="merchants"
      getComponent={Merchants}
      queries={AppHomeRoute.queries}
    >
      <Route
        path=":merchantName/:branchName/:id"
        getComponent={Merchant}
        queries={MerchantRoute.queries}
      />
    </Route>
    <Route path="privacy" getComponent={Privacy} />
    <Route
      path="terms"
      getComponent={Terms}
      render={(args) => PageLoading(Terms, args)}
    />
    <Route path="careers" getComponent={Careers}>
      <IndexRoute getComponent={CareersHome} />
      <Route
        path="management-trainee-cebu"
        getComponent={ManagementTraineeCebu}
      />
      <Route
        path="management-trainee-manila"
        getComponent={ManagementTraineeManila}
      />
      <Route path="developer-manila" getComponent={DeveloperManila} />
    </Route>
    <Route
      path="dashboard"
      getComponent={Dashboard}
      queries={AppHomeRoute.queries}
    />
    <Route
      path="transactions"
      getComponent={Transactions}
      queries={AppHomeRoute.queries}
    />
    <Route path="wallet" getComponent={Wallet} queries={AppHomeRoute.queries} />
    <Route
      path="profile"
      getComponent={Profile}
      queries={AppHomeRoute.queries}
    />
    {resetPasswordRoutes()}
    {registerRoutes()}
    <Route path="app" getComponent={RedirectToStore} />
    <Redirect from="!/*" to="/*" />
    <Redirect from="*" to="/" />
  </Route>
);



// WEBPACK FOOTER //
// ./js/MainRoutes.js